import {
  EscHotKeyIcon,
  ReturnHotKeyIcon,
} from '@modules/common/components/HotKeyIcons';
import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';

interface SubscribedFeedSaveConfirmationDialogContentProps {
  onSave: () => void;
  onClose: () => void;
  isLoading: boolean;
}

export const SubscribedFeedSaveConfirmationDialogContent = ({
  onSave,
  onClose,
  isLoading,
}: SubscribedFeedSaveConfirmationDialogContentProps) => {
  return (
    <>
      <ModalHeader title="Save changes to Feed?" onClose={onClose} />
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          onSave();
        }}
      >
        <DialogContent dividers>
          <Stack py={2}>
            <Typography variant="body2">
              This Feed has an active subscription. Are you sure you want to
              save your changes to the Feed?
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" m={2} spacing={3}>
            <Button
              variant="outlined"
              onClick={onClose}
              type="button"
              endIcon={<EscHotKeyIcon isDisabled={isLoading} />}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <LoadingButton
              variant="contained"
              type="submit"
              endIcon={<ReturnHotKeyIcon isDisabled={isLoading} />}
              loading={isLoading}
            >
              Save
            </LoadingButton>
          </Stack>
        </DialogActions>
      </Box>
    </>
  );
};
